module.exports = __webpack_public_path__ + "img/m_award_img01.9d50c2e9.jpg";